import React, { useCallback, useEffect, useRef, useState } from "react";
import "./auth-testimonials.scss";

interface Slide {
  pain: string;
  description: string;
  mockup: React.ReactNode;
}

// SVG Mockups matching real Upwex UI (Maglo design: #232325 cards, #1C1C1E bg, #2C2C30 borders)

const MockupTemplates = () => (
  <svg viewBox="0 0 440 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%' }}>
    <defs><style>{`
      @keyframes tp-row1-hl { 0%,30%{fill:transparent} 35%,75%{fill:rgba(34,197,94,0.05)} 80%,100%{fill:transparent} }
      @keyframes tp-cursor { 0%,15%{transform:translate(200px,140px);opacity:0} 20%{opacity:1} 35%{transform:translate(380px,120px)} 40%,50%{transform:translate(382px,122px)} 52%{transform:translate(380px,120px)} 55%{opacity:0} 100%{opacity:0} }
      @keyframes tp-rate-pulse { 0%,35%{fontSize:9px} 42%,55%{fontSize:11px} 60%,100%{fontSize:9px} }
      .tp-row1{animation:tp-row1-hl 8s ease infinite}
      .tp-cursor{animation:tp-cursor 8s ease-in-out infinite}
      .tp-rate1{animation:tp-rate-pulse 8s ease infinite}
    `}</style></defs>

    {/* Hero cards */}
    <rect x="0" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="12" y="22" fill="#fff" fontSize="20" fontWeight="700">3</text>
    <text x="12" y="40" fill="#929EAE" fontSize="7">Templates</text>
    <rect x="112" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="124" y="22" fill="#fff" fontSize="20" fontWeight="700">161</text>
    <text x="124" y="40" fill="#929EAE" fontSize="7">Proposals Sent</text>
    <rect x="224" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="236" y="22" fill="#fff" fontSize="20" fontWeight="700">18</text>
    <text x="236" y="40" fill="#929EAE" fontSize="7">Replies</text>
    <rect x="336" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="348" y="22" fill="#22C55E" fontSize="20" fontWeight="700">11.2<tspan fill="#929EAE" fontSize="12">%</tspan></text>
    <text x="348" y="40" fill="#929EAE" fontSize="7">Avg Reply Rate</text>

    <text x="0" y="74" fill="#929EAE" fontSize="8" fontWeight="600">ALL TEMPLATES</text>
    <rect x="0" y="82" width="440" height="22" rx="6" fill="#252528" />
    <text x="12" y="96" fill="#78778B" fontSize="7" fontWeight="600">NAME</text>
    <text x="270" y="96" fill="#78778B" fontSize="7" fontWeight="600">SENT</text>
    <text x="310" y="96" fill="#78778B" fontSize="7" fontWeight="600">REPLIES</text>
    <text x="358" y="96" fill="#78778B" fontSize="7" fontWeight="600">RATE</text>
    <text x="408" y="96" fill="#78778B" fontSize="7" fontWeight="600">OFFERS</text>

    {/* Row 1 - animated highlight */}
    <rect x="0" y="104" width="440" height="26" className="tp-row1" />
    <line x1="0" y1="130" x2="440" y2="130" stroke="#2C2C30" strokeWidth="0.5" />
    <text x="12" y="118" fill="#fff" fontSize="9" fontWeight="600">Cover Letter #1</text>
    <rect x="112" y="109" width="46" height="14" rx="7" fill="rgba(34,197,94,0.12)" />
    <text x="120" y="119" fill="#22C55E" fontSize="7" fontWeight="600">DEFAULT</text>
    <text x="12" y="128" fill="#78778B" fontSize="7">Greet the client by name if available...</text>
    <text x="278" y="122" fill="#fff" fontSize="9">47</text>
    <text x="322" y="122" fill="#fff" fontSize="9">12</text>
    <text x="358" y="122" fill="#22C55E" fontWeight="600" className="tp-rate1">25.5%</text>
    <text x="416" y="122" fill="#fff" fontSize="9">4</text>

    {/* Row 2 */}
    <line x1="0" y1="162" x2="440" y2="162" stroke="#2C2C30" strokeWidth="0.5" />
    <text x="12" y="148" fill="#fff" fontSize="9" fontWeight="600">Cover Letter #2</text>
    <text x="12" y="159" fill="#78778B" fontSize="7">STRUCTURE (80-120 words), greeting + hook...</text>
    <text x="278" y="153" fill="#fff" fontSize="9">83</text>
    <text x="322" y="153" fill="#fff" fontSize="9">5</text>
    <text x="358" y="153" fill="#FBBF24" fontSize="9" fontWeight="600">6.0%</text>
    <text x="416" y="153" fill="#fff" fontSize="9">2</text>

    {/* Row 3 */}
    <text x="12" y="180" fill="#fff" fontSize="9" fontWeight="600">Cover Letter #3</text>
    <text x="12" y="191" fill="#78778B" fontSize="7">Generic intro with portfolio links...</text>
    <text x="278" y="185" fill="#fff" fontSize="9">31</text>
    <text x="322" y="185" fill="#fff" fontSize="9">1</text>
    <text x="358" y="185" fill="#F87171" fontSize="9" fontWeight="600">3.2%</text>
    <text x="416" y="185" fill="#fff" fontSize="9">0</text>

    {/* Cursor */}
    <g className="tp-cursor"><path d="M0,0 L0,14 L4,10 L8,16 L10,15 L6,9 L11,8 Z" fill="#fff" stroke="#000" strokeWidth="0.5" /></g>
  </svg>
);

const MockupFunnel = () => (
  <svg viewBox="0 0 440 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%' }}>
    <defs><style>{`
      @keyframes fn-grow { 0%{transform:scaleY(0)} 15%{transform:scaleY(1)} 100%{transform:scaleY(1)} }
      @keyframes fn-line { 0%,15%{opacity:0} 25%{opacity:1} 100%{opacity:1} }
      @keyframes fn-cursor { 0%,40%{transform:translate(100px,150px);opacity:0} 45%{opacity:1} 55%{transform:translate(226px,72px)} 60%,70%{transform:translate(228px,74px)} 75%{opacity:0} 100%{opacity:0} }
      @keyframes fn-tooltip { 0%,55%{opacity:0} 60%,72%{opacity:1} 75%,100%{opacity:0} }
      .fn-bar{transform-origin:bottom;animation:fn-grow 8s ease-out infinite}
      .fn-bar-d1{animation-delay:0.1s} .fn-bar-d2{animation-delay:0.2s} .fn-bar-d3{animation-delay:0.3s}
      .fn-bar-d4{animation-delay:0.4s} .fn-bar-d5{animation-delay:0.5s} .fn-bar-d6{animation-delay:0.6s}
      .fn-line{animation:fn-line 8s ease infinite}
      .fn-cursor{animation:fn-cursor 8s ease-in-out infinite}
      .fn-tooltip{animation:fn-tooltip 8s ease infinite}
    `}</style></defs>

    {/* Hero cards */}
    <rect x="0" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="12" y="24" fill="#22C55E" fontSize="20" fontWeight="700">396</text>
    <text x="12" y="40" fill="#929EAE" fontSize="7">Jobs Viewed</text>
    <rect x="112" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="124" y="24" fill="#22C55E" fontSize="20" fontWeight="700">130</text>
    <text x="124" y="40" fill="#929EAE" fontSize="7">Proposals Sent</text>
    <rect x="224" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="236" y="24" fill="#22C55E" fontSize="20" fontWeight="700">29</text>
    <text x="236" y="40" fill="#929EAE" fontSize="7">Replies</text>
    <rect x="336" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="348" y="24" fill="#22C55E" fontSize="20" fontWeight="700">22.3<tspan fill="#929EAE" fontSize="12">%</tspan></text>
    <text x="348" y="40" fill="#929EAE" fontSize="7">Reply Rate</text>

    {/* Bars with grow animation */}
    {[0,1,2,3,4,5,6].map(i => {
      const x = 20 + i * 60;
      const jobs = [12,18,15,22,14,10,20][i];
      const bids = [8,14,10,16,9,7,15][i];
      const replies = [2,4,2,5,3,1,4][i];
      const offers = [0,1,1,2,1,0,1][i];
      return (
        <g key={i}>
          <rect x={x} y={185 - jobs * 4} width="12" height={jobs * 4} rx="2" fill="#F59E0B" opacity="0.8" className={`fn-bar fn-bar-d${i % 7}`} />
          <rect x={x + 13} y={185 - bids * 4} width="12" height={bids * 4} rx="2" fill="#A78BFA" opacity="0.8" className={`fn-bar fn-bar-d${(i+1) % 7}`} />
          <rect x={x + 26} y={185 - replies * 6} width="12" height={replies * 6} rx="2" fill="#60A5FA" opacity="0.8" className={`fn-bar fn-bar-d${(i+2) % 7}`} />
          <rect x={x + 39} y={185 - offers * 10} width="12" height={offers * 10} rx="2" fill="#EC4899" opacity="0.8" className={`fn-bar fn-bar-d${(i+3) % 7}`} />
          <text x={x + 25} y="197" fill="#78778B" fontSize="6" textAnchor="middle">{['Mon','Tue','Wed','Thu','Fri','Sat','Sun'][i]}</text>
        </g>
      );
    })}
    {/* Reply rate line */}
    <polyline points="46,100 106,82 166,95 226,72 286,90 346,108 406,78" stroke="#22C55E" strokeWidth="1.5" fill="none" strokeLinecap="round" className="fn-line" />
    {[46,106,166,226,286,346,406].map((x,i) => (
      <circle key={i} cx={x} cy={[100,82,95,72,90,108,78][i]} r="2.5" fill="#22C55E" className="fn-line" />
    ))}
    <line x1="15" y1="186" x2="435" y2="186" stroke="#2C2C30" strokeWidth="0.5" />

    {/* Legend */}
    <rect x="80" y="62" width="6" height="6" rx="1" fill="#F59E0B" /><text x="90" y="68" fill="#78778B" fontSize="6">Jobs</text>
    <rect x="120" y="62" width="6" height="6" rx="1" fill="#A78BFA" /><text x="130" y="68" fill="#78778B" fontSize="6">Proposals</text>
    <rect x="178" y="62" width="6" height="6" rx="1" fill="#60A5FA" /><text x="188" y="68" fill="#78778B" fontSize="6">Replies</text>
    <rect x="224" y="62" width="6" height="6" rx="1" fill="#EC4899" /><text x="234" y="68" fill="#78778B" fontSize="6">Offers</text>
    <rect x="280" y="62" width="16" height="1.5" rx="0.75" fill="#22C55E" /><text x="300" y="68" fill="#78778B" fontSize="6">Rate %</text>

    {/* Tooltip on hover - rendered last to be on top */}
    <g className="fn-tooltip">
      <rect x="200" y="42" width="78" height="22" rx="4" fill="#1C1C1E" stroke="#2C2C30" strokeWidth="1" />
      <text x="239" y="57" fill="#fff" fontSize="8" fontWeight="600" textAnchor="middle">Thu: 22.7%</text>
    </g>

    <g className="fn-cursor"><path d="M0,0 L0,14 L4,10 L8,16 L10,15 L6,9 L11,8 Z" fill="#fff" stroke="#000" strokeWidth="0.5" /></g>
  </svg>
);

const MockupAutoBid = () => (
  <svg viewBox="0 0 440 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%' }}>
    <defs><style>{`
      @keyframes ab-scan { 0%{x:15} 100%{x:435} }
      @keyframes ab-pulse { 0%,100%{opacity:0.3} 50%{opacity:0.8} }
      @keyframes ab-grow { 0%{transform:scaleY(0)} 20%{transform:scaleY(1)} 100%{transform:scaleY(1)} }
      @keyframes ab-num { 0%{opacity:0} 10%{opacity:1} 100%{opacity:1} }
      .ab-scan-line{animation:ab-scan 4s linear infinite}
      .ab-pulse{animation:ab-pulse 2s ease infinite}
      .ab-bar{transform-origin:bottom;animation:ab-grow 8s ease-out infinite}
      .ab-num{animation:ab-num 8s ease infinite}
    `}</style></defs>

    {/* Hero cards with count-up feel */}
    <rect x="0" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="12" y="24" fill="#fff" fontSize="20" fontWeight="700" className="ab-num">88</text>
    <text x="12" y="40" fill="#929EAE" fontSize="7">Jobs Scanned</text>
    <rect x="112" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="124" y="24" fill="#22C55E" fontSize="20" fontWeight="700" className="ab-num">24</text>
    <text x="124" y="40" fill="#929EAE" fontSize="7">Submitted</text>
    <rect x="224" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="236" y="24" fill="#fff" fontSize="20" fontWeight="700" className="ab-num">7</text>
    <text x="236" y="40" fill="#929EAE" fontSize="7">Replies</text>
    <rect x="336" y="0" width="105" height="52" rx="10" fill="#232325" />
    <text x="348" y="24" fill="#22C55E" fontSize="20" fontWeight="700" className="ab-num">29.2<tspan fill="#929EAE" fontSize="12">%</tspan></text>
    <text x="348" y="40" fill="#929EAE" fontSize="7">Reply Rate</text>

    {/* Scanning indicator line */}
    <rect x="15" y="62" width="3" height="124" rx="1" fill="#22C55E" opacity="0.4" className="ab-scan-line" />

    {/* Status indicator */}
    <circle cx="30" cy="68" r="4" fill="#22C55E" className="ab-pulse" />
    <text x="38" y="71" fill="#22C55E" fontSize="7" fontWeight="600">Auto-bidding active</text>

    {/* Bars */}
    {[0,1,2,3,4,5,6].map(i => {
      const x = 20 + i * 60;
      const scanned = [14,18,12,20,16,10,18][i];
      const submitted = [3,5,2,4,3,1,4][i];
      const replies = [1,2,0,1,1,0,2][i];
      const offers = [0,1,0,1,0,0,1][i];
      return (
        <g key={i}>
          <rect x={x} y={185 - scanned * 4.5} width="12" height={scanned * 4.5} rx="2" fill="#78778B" opacity="0.6" className="ab-bar" />
          <rect x={x + 13} y={185 - submitted * 10} width="12" height={submitted * 10} rx="2" fill="#60A5FA" opacity="0.8" className="ab-bar" />
          <rect x={x + 26} y={185 - replies * 14} width="12" height={replies * 14} rx="2" fill="#A78BFA" opacity="0.8" className="ab-bar" />
          <rect x={x + 39} y={185 - offers * 18} width="12" height={offers * 18} rx="2" fill="#EC4899" opacity="0.8" className="ab-bar" />
          <text x={x + 25} y="197" fill="#78778B" fontSize="6" textAnchor="middle">{['Mon','Tue','Wed','Thu','Fri','Sat','Sun'][i]}</text>
        </g>
      );
    })}
    <polyline points="46,145 106,130 166,155 226,135 286,140 346,160 406,132" stroke="#22C55E" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <line x1="15" y1="186" x2="435" y2="186" stroke="#2C2C30" strokeWidth="0.5" />
    <rect x="100" y="78" width="6" height="6" rx="1" fill="#78778B" opacity="0.6" /><text x="110" y="84" fill="#78778B" fontSize="6">Scanned</text>
    <rect x="155" y="78" width="6" height="6" rx="1" fill="#60A5FA" /><text x="165" y="84" fill="#78778B" fontSize="6">Submitted</text>
    <rect x="215" y="78" width="6" height="6" rx="1" fill="#A78BFA" /><text x="225" y="84" fill="#78778B" fontSize="6">Replies</text>
    <rect x="270" y="78" width="6" height="6" rx="1" fill="#EC4899" /><text x="280" y="84" fill="#78778B" fontSize="6">Offers</text>
  </svg>
);

const MockupConnects = () => (
  <svg viewBox="0 0 440 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%' }}>
    <defs><style>{`
      @keyframes cn-grow { 0%{transform:scaleY(0)} 18%{transform:scaleY(1)} 100%{transform:scaleY(1)} }
      @keyframes cn-line { 0%,20%{strokeDashoffset:500} 40%{strokeDashoffset:0} 100%{strokeDashoffset:0} }
      @keyframes cn-cursor { 0%,45%{transform:translate(100px,130px);opacity:0} 50%{opacity:1} 60%{transform:translate(189px,118px)} 65%,75%{transform:translate(191px,120px)} 78%{opacity:0} 100%{opacity:0} }
      @keyframes cn-tip { 0%,58%{opacity:0} 62%,76%{opacity:1} 78%,100%{opacity:0} }
      .cn-bar{transform-origin:bottom;animation:cn-grow 8s ease-out infinite}
      .cn-line{stroke-dasharray:500;animation:cn-line 8s ease infinite}
      .cn-cursor{animation:cn-cursor 8s ease-in-out infinite}
      .cn-tip{animation:cn-tip 8s ease infinite}
    `}</style></defs>

    <rect x="0" y="0" width="140" height="52" rx="10" fill="#232325" />
    <text x="12" y="24" fill="#22C55E" fontSize="20" fontWeight="700">1,240</text>
    <text x="12" y="40" fill="#929EAE" fontSize="7">Connects Used</text>
    <rect x="150" y="0" width="140" height="52" rx="10" fill="#232325" />
    <text x="162" y="24" fill="#fff" fontSize="20" fontWeight="700">$12.40</text>
    <text x="162" y="40" fill="#929EAE" fontSize="7">Cost per Reply</text>
    <rect x="300" y="0" width="140" height="52" rx="10" fill="#232325" />
    <text x="312" y="24" fill="#FBBF24" fontSize="20" fontWeight="700">16.2</text>
    <text x="312" y="40" fill="#929EAE" fontSize="7">Avg. per Proposal</text>

    {[0,1,2,3,4,5,6,7].map(i => {
      const x = 22 + i * 52;
      const connects = [80,120,55,140,90,105,65,130][i];
      const bids = [5,8,3,9,6,7,4,8][i];
      return (
        <g key={i}>
          <rect x={x} y={185 - connects * 0.8} width="20" height={connects * 0.8} rx="3" fill="#FB923C" opacity="0.7" className="cn-bar" />
          <rect x={x + 22} y={185 - bids * 8} width="20" height={bids * 8} rx="3" fill="#A78BFA" opacity="0.7" className="cn-bar" />
        </g>
      );
    })}
    <polyline points="33,140 85,125 137,150 189,118 241,135 293,128 345,145 397,122" stroke="#38BDF8" strokeWidth="1.5" fill="none" strokeLinecap="round" className="cn-line" />
    <line x1="15" y1="186" x2="435" y2="186" stroke="#2C2C30" strokeWidth="0.5" />

    {/* Tooltip */}
    <g className="cn-tip">
      <rect x="160" y="100" width="80" height="26" rx="4" fill="#1C1C1E" stroke="#2C2C30" strokeWidth="0.5" />
      <text x="170" y="113" fill="#FB923C" fontSize="7" fontWeight="600">140 connects</text>
      <text x="170" y="123" fill="#A78BFA" fontSize="7">9 proposals</text>
    </g>

    <rect x="120" y="62" width="6" height="6" rx="1" fill="#FB923C" /><text x="130" y="68" fill="#78778B" fontSize="6">Connects</text>
    <rect x="180" y="62" width="6" height="6" rx="1" fill="#A78BFA" /><text x="190" y="68" fill="#78778B" fontSize="6">Proposals</text>
    <rect x="245" y="62" width="16" height="1.5" rx="0.75" fill="#38BDF8" /><text x="265" y="68" fill="#78778B" fontSize="6">Connects/Bid</text>

    <g className="cn-cursor"><path d="M0,0 L0,14 L4,10 L8,16 L10,15 L6,9 L11,8 Z" fill="#fff" stroke="#000" strokeWidth="0.5" /></g>
  </svg>
);

const MockupAiAnalysis = () => (
  <svg viewBox="0 0 440 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%' }}>
    <defs><style>{`
      @keyframes cf-widget { 0%,18%{transform:translateX(20px);opacity:0} 25%{transform:translateX(0);opacity:1} 100%{transform:translateX(0);opacity:1} }
      @keyframes cf-cursor { 0%,25%{transform:translate(200px,100px);opacity:0} 30%{opacity:1} 40%{transform:translate(370px,54px)} 44%,48%{transform:translate(372px,56px)} 50%{transform:translate(370px,54px)} 52%{opacity:0} 100%{opacity:0} }
      @keyframes cf-btn-click { 0%,43%{opacity:1} 45%,50%{opacity:0.6} 52%,100%{opacity:1} }
      @keyframes cf-greeting { 0%,50%{opacity:1} 52%{opacity:0} 100%{opacity:0} }
      @keyframes cf-results { 0%,52%{opacity:0} 56%{opacity:1} 100%{opacity:1} }
      @keyframes cf-score { 0%,56%{width:0} 68%{width:64px} 100%{width:64px} }
      @keyframes cf-r1 { 0%,58%{opacity:0;transform:translateY(6px)} 64%{opacity:1;transform:translateY(0)} 100%{opacity:1} }
      @keyframes cf-r2 { 0%,66%{opacity:0;transform:translateY(6px)} 72%{opacity:1;transform:translateY(0)} 100%{opacity:1} }
      @keyframes cf-r3 { 0%,74%{opacity:0;transform:translateY(6px)} 80%{opacity:1;transform:translateY(0)} 100%{opacity:1} }
      .cf-widget{animation:cf-widget 10s ease infinite}
      .cf-cursor{animation:cf-cursor 10s ease-in-out infinite}
      .cf-btn{animation:cf-btn-click 10s ease infinite}
      .cf-greeting{animation:cf-greeting 10s ease infinite}
      .cf-results{animation:cf-results 10s ease infinite}
      .cf-score-bar{animation:cf-score 10s ease infinite}
      .cf-r1{animation:cf-r1 10s ease infinite}
      .cf-r2{animation:cf-r2 10s ease infinite}
      .cf-r3{animation:cf-r3 10s ease infinite}
    `}</style></defs>

    {/* Upwork job page background */}
    <rect x="0" y="0" width="440" height="200" fill="#1a1a1a" />
    <rect x="0" y="0" width="440" height="24" fill="#1d4d2b" />
    <text x="16" y="16" fill="#fff" fontSize="9" fontWeight="600">Upwork</text>
    <rect x="70" y="7" width="40" height="10" rx="3" fill="rgba(255,255,255,0.15)" />

    {/* Job listing content */}
    <text x="20" y="48" fill="#fff" fontSize="11" fontWeight="600">React Dashboard with Real-Time Charts</text>
    <text x="20" y="62" fill="#929EAE" fontSize="8">Fixed-price: $2,500 . Expert . Posted 2 hours ago</text>
    <rect x="20" y="74" width="255" height="6" rx="2" fill="#333" />
    <rect x="20" y="84" width="260" height="6" rx="2" fill="#333" />
    <rect x="20" y="94" width="245" height="6" rx="2" fill="#333" />
    <rect x="20" y="104" width="230" height="6" rx="2" fill="#333" />
    <rect x="20" y="114" width="255" height="6" rx="2" fill="#333" />
    <rect x="20" y="128" width="60" height="16" rx="4" fill="#252528" />
    <text x="30" y="139" fill="#78778B" fontSize="7">React</text>
    <rect x="86" y="128" width="72" height="16" rx="4" fill="#252528" />
    <text x="94" y="139" fill="#78778B" fontSize="7">TypeScript</text>
    <rect x="164" y="128" width="58" height="16" rx="4" fill="#252528" />
    <text x="172" y="139" fill="#78778B" fontSize="7">Node.js</text>
    <rect x="228" y="128" width="44" height="16" rx="4" fill="#252528" />
    <text x="234" y="139" fill="#78778B" fontSize="7">D3.js</text>
    <rect x="20" y="154" width="72" height="28" rx="6" fill="#1d4d2b" />
    <text x="56" y="172" fill="#fff" fontSize="9" fontWeight="600" textAnchor="middle">Apply Now</text>

    {/* Upwex widget slides in */}
    <g className="cf-widget">
      <rect x="295" y="30" width="138" height="165" rx="14" fill="#1C1C1E" stroke="#2C2C30" strokeWidth="1" />
      <rect x="307" y="40" width="18" height="18" rx="9" fill="#162B1D" />
      <text x="316" y="53" fill="#22C55E" fontSize="7" fontWeight="700" textAnchor="middle">U</text>
      <text x="330" y="52" fill="#fff" fontSize="8" fontWeight="600">Upwex AI</text>
      <line x1="295" y1="64" x2="433" y2="64" stroke="#2C2C30" strokeWidth="0.5" />

      {/* Greeting state - CheckFit button */}
      <g className="cf-greeting">
        <text x="310" y="82" fill="#fff" fontSize="8" fontWeight="500">Analyze this job?</text>
        <rect x="305" y="90" width="120" height="28" rx="8" fill="#146834" className="cf-btn" />
        <text x="365" y="108" fill="#fff" fontSize="9" fontWeight="600" textAnchor="middle">CheckFit</text>
        <rect x="305" y="124" width="120" height="28" rx="8" fill="#252528" stroke="#2C2C30" strokeWidth="0.5" />
        <text x="365" y="142" fill="#929EAE" fontSize="8" textAnchor="middle">Auto Bid</text>
        <rect x="305" y="158" width="120" height="28" rx="8" fill="#252528" stroke="#2C2C30" strokeWidth="0.5" />
        <text x="365" y="176" fill="#929EAE" fontSize="8" textAnchor="middle">Cover Letter</text>
      </g>

      {/* Results state - appears after click */}
      <g className="cf-results">
        {/* Score */}
        <g className="cf-r1">
          <text x="310" y="80" fill="#22C55E" fontSize="8" fontWeight="600">Match Score</text>
          <rect x="310" y="84" width="80" height="4" rx="2" fill="#252528" />
          <rect x="310" y="84" height="4" rx="2" fill="#22C55E" className="cf-score-bar" />
          <text x="396" y="89" fill="#22C55E" fontSize="8" fontWeight="700">80%</text>
        </g>

        {/* Red flag */}
        <g className="cf-r2">
          <text x="310" y="106" fill="#F87171" fontSize="8" fontWeight="600">Red Flags</text>
          <rect x="310" y="110" width="116" height="16" rx="4" fill="rgba(248,113,113,0.06)" />
          <text x="314" y="121" fill="#F87171" fontSize="6">Low budget for scope</text>
        </g>

        {/* Client */}
        <g className="cf-r3">
          <text x="310" y="140" fill="#60A5FA" fontSize="8" fontWeight="600">Client</text>
          <text x="310" y="152" fill="#929EAE" fontSize="6">Verified . $45K spent</text>
          <text x="310" y="162" fill="#929EAE" fontSize="6">92% hire rate</text>
          <text x="310" y="178" fill="#FBBF24" fontSize="8" fontWeight="600">74 proposals</text>
          <text x="310" y="188" fill="#929EAE" fontSize="6">avg bid $35/hr</text>
        </g>
      </g>
    </g>

    {/* Cursor */}
    <g className="cf-cursor"><path d="M0,0 L0,14 L4,10 L8,16 L10,15 L6,9 L11,8 Z" fill="#fff" stroke="#000" strokeWidth="0.5" /></g>
  </svg>
);

const MockupOneClick = () => (
  <svg viewBox="0 0 440 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%' }}>
    <defs>
      <style>{`
        @keyframes oc-cursor { 0%,10%{transform:translate(200px,100px);opacity:0} 15%{opacity:1} 30%{transform:translate(365px,97px);opacity:1} 35%,40%{transform:translate(365px,99px)} 42%{transform:translate(365px,97px)} 45%{opacity:0} 100%{opacity:0} }
        @keyframes oc-btn-click { 0%,34%{opacity:1} 35%,42%{opacity:0.7} 43%,100%{opacity:1} }
        @keyframes oc-fill-text { 0%,42%{opacity:0} 46%{opacity:1} 100%{opacity:1} }
        @keyframes oc-fill-line1 { 0%,42%{width:0} 48%{width:240px} 100%{width:240px} }
        @keyframes oc-fill-line2 { 0%,48%{width:0} 54%{width:200px} 100%{width:200px} }
        @keyframes oc-fill-line3 { 0%,54%{width:0} 60%{width:220px} 100%{width:220px} }
        @keyframes oc-placeholder { 0%,42%{opacity:1} 46%{opacity:0} 100%{opacity:0} }
        @keyframes oc-check { 0%,62%{opacity:0;transform:scale(0)} 66%{opacity:1;transform:scale(1.2)} 70%,100%{opacity:1;transform:scale(1)} }
        @keyframes oc-submit-glow { 0%,68%{fill:#1d4d2b} 72%,82%{fill:#146834} 85%,100%{fill:#1d4d2b} }
        .oc-cursor{animation:oc-cursor 8s ease-in-out infinite}
        .oc-btn{animation:oc-btn-click 8s ease infinite}
        .oc-fill-text{animation:oc-fill-text 8s ease infinite}
        .oc-line1{animation:oc-fill-line1 8s ease infinite}
        .oc-line2{animation:oc-fill-line2 8s ease infinite}
        .oc-line3{animation:oc-fill-line3 8s ease infinite}
        .oc-placeholder{animation:oc-placeholder 8s ease infinite}
        .oc-check{animation:oc-check 8s ease infinite;transform-origin:46px 92px}
        .oc-submit{animation:oc-submit-glow 8s ease infinite}
      `}</style>
    </defs>

    {/* Upwork page */}
    <rect x="0" y="0" width="440" height="200" fill="#1a1a1a" />
    <rect x="0" y="0" width="440" height="24" fill="#1d4d2b" />
    <text x="16" y="16" fill="#fff" fontSize="9" fontWeight="600">Upwork</text>
    <rect x="70" y="7" width="40" height="10" rx="3" fill="rgba(255,255,255,0.15)" />

    {/* Form */}
    <text x="20" y="44" fill="#fff" fontSize="10" fontWeight="600">Submit a Proposal</text>
    <rect x="20" y="52" width="260" height="8" rx="2" fill="#333" />
    <rect x="20" y="66" width="260" height="50" rx="6" fill="#252525" stroke="#3a3a3a" strokeWidth="0.5" />
    <text x="30" y="82" fill="#555" fontSize="8" className="oc-placeholder">Add a cover letter...</text>

    {/* Animated cover letter text */}
    <g className="oc-fill-text">
      <text x="28" y="78" fill="#ccc" fontSize="7">Hi Sarah, I noticed your project needs a React expert with...</text>
      <text x="28" y="89" fill="#ccc" fontSize="7">I have 5+ years building similar dashboards and can deliver...</text>
      <text x="28" y="100" fill="#ccc" fontSize="7">Would love to discuss the timeline. Best regards, Alex</text>
    </g>

    {/* Check mark after fill */}
    <g className="oc-check">
      <circle cx="46" cy="92" r="6" fill="#22C55E" opacity="0.2" />
      <text x="46" y="95" fill="#22C55E" fontSize="8" fontWeight="700" textAnchor="middle">✓</text>
    </g>

    <rect x="20" y="124" width="120" height="8" rx="2" fill="#333" />
    <rect x="20" y="140" width="80" height="24" rx="6" fill="#333" stroke="#3a3a3a" strokeWidth="0.5" />
    <rect x="20" y="172" width="56" height="24" rx="6" className="oc-submit" />
    <text x="48" y="187" fill="#fff" fontSize="8" fontWeight="600" textAnchor="middle">Submit</text>

    {/* Upwex widget */}
    <rect x="300" y="34" width="130" height="158" rx="14" fill="#1C1C1E" stroke="#2C2C30" strokeWidth="1" />
    <rect x="312" y="46" width="20" height="20" rx="10" fill="#162B1D" />
    <text x="322" y="60" fill="#22C55E" fontSize="8" fontWeight="700" textAnchor="middle">U</text>
    <text x="338" y="58" fill="#fff" fontSize="9" fontWeight="600">Upwex AI</text>
    <line x1="300" y1="72" x2="430" y2="72" stroke="#2C2C30" strokeWidth="0.5" />

    <rect x="312" y="82" width="106" height="30" rx="8" fill="#146834" className="oc-btn" />
    <text x="365" y="101" fill="#fff" fontSize="9" fontWeight="600" textAnchor="middle">Auto Bid</text>

    <rect x="312" y="118" width="106" height="30" rx="8" fill="#252528" stroke="#2C2C30" strokeWidth="0.5" />
    <text x="365" y="137" fill="#929EAE" fontSize="9" textAnchor="middle">Autocomplete</text>

    <rect x="312" y="154" width="106" height="30" rx="8" fill="#252528" stroke="#2C2C30" strokeWidth="0.5" />
    <text x="365" y="173" fill="#929EAE" fontSize="9" textAnchor="middle">Cover Letter</text>

    {/* Animated cursor */}
    <g className="oc-cursor">
      <path d="M0,0 L0,14 L4,10 L8,16 L10,15 L6,9 L11,8 Z" fill="#fff" stroke="#000" strokeWidth="0.5" />
    </g>
  </svg>
);

const sharedSlides: Slide[] = [
  {
    pain: "Open a job, click one button, done?",
    description: 'AI generates a cover letter, answers questions, fills your rate. <mark>30 seconds per proposal</mark> instead of 30 minutes. All inside Upwork.',
    mockup: <MockupOneClick />,
  },
  {
    pain: "Check any job before you bid",
    description: 'AI analyzes match score, client history, budget red flags, and competition level. <mark>Avoid bad clients</mark> and save connects on dead-end jobs.',
    mockup: <MockupAiAnalysis />,
  },
  {
    pain: "Writing proposals blindly?",
    description: 'Create multiple cover letter templates. See which one gets the most replies and offers. <mark>2x higher reply rate</mark> when you double down on what works.',
    mockup: <MockupTemplates />,
  },
  {
    pain: "No idea where you're losing clients?",
    description: 'Track your entire pipeline: Jobs, Proposals, Replies, Offers. <mark>Find your weak spot</mark> and fix it with data, not guesses.',
    mockup: <MockupFunnel />,
  },
  {
    pain: "Best jobs gone before you see them?",
    description: 'AI scans new jobs 24/7, evaluates each one, generates a personalized proposal, and submits automatically. <mark>10x more proposals</mark> with zero extra effort.',
    mockup: <MockupAutoBid />,
  },
  {
    pain: "Wasting connects on dead-end jobs?",
    description: 'See your real cost per reply and whether boosting helps. <mark>Save 40% connects</mark> by spending smarter, not more.',
    mockup: <MockupConnects />,
  },
];

// Login and Register use the same slides

const INTERVAL_MS = 7000;

interface Props {
  variant?: "login" | "register";
}

export const AuthTestimonials = ({ variant = "register" }: Props): JSX.Element => {
  const slides = sharedSlides;
  const [current, setCurrent] = useState(0);
  const [progressKey, setProgressKey] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval>>();
  const isPaused = useRef(false);

  const startInterval = useCallback(() => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      if (!isPaused.current) {
        setCurrent((prev) => (prev + 1) % slides.length);
        setProgressKey((k) => k + 1);
      }
    }, INTERVAL_MS);
  }, [slides.length]);

  useEffect(() => {
    startInterval();
    return () => clearInterval(intervalRef.current);
  }, [startInterval]);

  const handleDotClick = (index: number) => {
    if (index === current) return;
    setCurrent(index);
    setProgressKey((k) => k + 1);
    clearInterval(intervalRef.current);
    startInterval();
  };

  return (
    <div
      className="auth-panel"
      onMouseEnter={() => (isPaused.current = true)}
      onMouseLeave={() => (isPaused.current = false)}
    >
      <div className="auth-panel__content">
        {/* Screenshot mockup */}
        <div className="auth-panel__screenshot">
          <div className="auth-panel__browser-dots">
            <span className="auth-panel__dot-red" />
            <span className="auth-panel__dot-yellow" />
            <span className="auth-panel__dot-green" />
          </div>
          <div className="auth-panel__screenshot-body">
            {slides.map((item, i) => (
              <div key={i} className={`auth-panel__mockup${i === current ? " auth-panel__mockup--active" : ""}`}>
                {item.mockup}
              </div>
            ))}
          </div>
        </div>

        {/* Text slides */}
        <div className="auth-panel__slider">
          {slides.map((item, i) => (
            <div
              key={i}
              className={`auth-panel__slide${i === current ? " auth-panel__slide--active" : ""}`}
            >
              <h2 className="auth-panel__pain">{item.pain}</h2>
              <p className="auth-panel__description" dangerouslySetInnerHTML={{ __html: item.description }} />
            </div>
          ))}
        </div>

        {/* Progress dots */}
        <div className="auth-panel__dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`auth-panel__dot${i === current ? " auth-panel__dot--active" : ""}`}
              onClick={() => handleDotClick(i)}
            >
              {i === current && (
                <span key={progressKey} className="auth-panel__dot-progress" />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
